import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

interface MessageSkeletonV2StylesProps {
  isYours: boolean
}

const useStyles = makeStyles<Theme, MessageSkeletonV2StylesProps>(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },

  container: {
    display: 'flex',
    flexDirection: ({ isYours }) => (isYours ? 'row-reverse' : 'row')
  },

  avatarLoading: {
    width: '2rem',
    height: '2rem',
    margin: '0 10px',
    padding: '0.125rem',
    fontSize: theme.size.sm,
    animation: '$skeleton-loading 0.3s linear infinite alternate',
    borderRadius: '50%',

    '& > span': {
      width: '2rem',
      height: '2rem'
    }
  },

  dividerContent: {
    width: '35%',
    height: 20,
    animation: '$skeleton-loading 0.3s linear infinite alternate'
  },

  msgContent: {
    width: '25%',
    marginRight: ({ isYours }) => isYours && 56,
    marginLeft: ({ isYours }) => !isYours && 56,
    borderRadius: ({ isYours }) =>
      isYours ? '16px 0px 16px 16px' : '0px 16px 16px',
    height: 45,
    animation: '$skeleton-loading 0.3s linear infinite alternate'
  },

  '@keyframes skeleton-loading': {
    '0%': {
      backgroundColor: 'hsl(0, 0%, 90%)'
    },
    '100%': {
      backgroundColor: 'hsl(0, 0%, 93%)'
    }
  }
}))

export default useStyles
